(function () {
    'use strict';

    //todo-alex löschen. wird nicht benötigt
    angular
        .module('uwAgenda.global')
        .service('ClientCacheService', ClientCacheServiceFn);

    ClientCacheServiceFn.$inject = ['CacheFactory'];

    /* service to store and retrieve items from local client cache */
    /* default options for CacheFactory are set globally in app.js */
    function ClientCacheServiceFn(CacheFactory) {
        var cacheObject = {};

        intialize();

        var service = {
            getItem: getItem
        };

        return service;

        /* returns the cached item if found, or caches the new item and returns the value */
        function getItem(key, item) {
            // call intialize method if cacheObject hasn't been initialized yet
            if (cacheObject === null || cacheObject === undefined)
                intialize();

            var cachedItem = cacheObject.get(key);
            if (cachedItem === null || cachedItem === undefined) {
                cachedItem = item;
                cacheObject.put(key, item);
            }

            return cachedItem;
        }

        /* intialize cache object if not done yet */
        function intialize() {
            if (!CacheFactory.get('cc'))
                cacheObject = CacheFactory.createCache('cc');
        }
    }
})();